import { useState } from "react";
import { Header } from "../components/Header";
import { ZSHeroSection } from "../components/zs/ZSHeroSection";
import { ZSBenefitsSection } from "../components/zs/ZSBenefitsSection";
import { ZSHowItWorksSection } from "../components/zs/ZSHowItWorksSection";
import { ZSFeaturesSection } from "../components/zs/ZSFeaturesSection";
import { ZSComplianceSection } from "../components/zs/ZSComplianceSection";
import { ZSFAQSection } from "../components/zs/ZSFAQSection";
import { ZSPricingSection } from "../components/zs/ZSPricingSection";
import { WebinarSection } from "../components/WebinarSection";
import { ContactSection } from "../components/ContactSection";
import { BackOfficeSection } from "../components/BackOfficeSection";
import { CTASection } from "../components/CTASection";
import { Footer } from "../components/Footer";
import { InfoRequestModal } from "../components/InfoRequestModal";
import { APP_URLS } from "../data/mock";

export default function ZSLandingPage() {
  const [infoModalOpen, setInfoModalOpen] = useState(false);

  const handleOrderClick = () => {
    const el = document.querySelector('#pricing');
    if (el) {
      const offset = 80;
      const top = el.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  const handleInfoClick = () => setInfoModalOpen(true);

  return (
    <div className="min-h-screen overflow-x-hidden">
      <ZSHeroSection onOrderClick={handleOrderClick} onInfoClick={handleInfoClick} />
      <ZSBenefitsSection />
      <ZSHowItWorksSection onOrderClick={handleOrderClick} onInfoClick={handleInfoClick} />
      <WebinarSection onOrderClick={handleOrderClick} schoolType="zs" />
      <ZSFeaturesSection />
      <ZSPricingSection />
      <ZSComplianceSection />
      <ZSFAQSection />
      <ContactSection />
      <BackOfficeSection />
      <InfoRequestModal open={infoModalOpen} onOpenChange={setInfoModalOpen} schoolType="zs" />
    </div>
  );
}
